module.exports = __webpack_public_path__ + "img/Tosee_Taavon.a59d0978.svg";